import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login.vue'
import ErrorPage from './views/error-500.vue'
import PrintLayout from './views/PrintLayout.vue'
import Settings from './views/Settings.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		
		{
			path: '/',
			name: 'PrintLayout',
			component: PrintLayout
		},
		{
			path: '/settings',
			name: 'Settings',
			component: Settings
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},

		{
			path: '/error',
			name: 'error-500',
			component: ErrorPage
		},

		{ path: '*', redirect: '/' }

	]
})
